module.exports = __webpack_public_path__ + "img/ocue-about-2.b759e55a.jpg";